import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationTextarea from "../components/PersonalizationTextarea";
import PersonalizationDivider from "../components/PersonalizationDivider";

export default function WellnessOpenIntroScreen({getWellnessError, wellnessFormData,setWellnessFormData}) {

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_open_intro_survey.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title'}
            value={wellnessFormData?.openEndedSectionTitle}
            setValue={(value) => setWellnessFormData({openEndedSectionTitle:value})}
            errorMessage={getWellnessError('wellnessSettings', 'openEndedSectionTitle')}
        />

        <PersonalizationDivider/>


        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_open_intro_pdf.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title on PDF'}
            value={wellnessFormData?.openEndedPdfTitle}
            setValue={(value) => setWellnessFormData({openEndedPdfTitle:value})}
            errorMessage={getWellnessError('wellnessSettings', 'openEndedPdfTitle')}
        />

    </div>
}
